// src/views/Parametros/Estados/EditarEstado.jsx
import React, { useState, useEffect } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import ModalBase from "../../../components/Modales/ModalBase";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";

export default function EditarEstado({
  id,
  onClose = () => {},
  onSaved = () => {},
}) {
  const [loading, setLoading] = useState(true);
  const [nombre, setNombre] = useState("");
  const [tipoId, setTipoId] = useState("");
  const [tiposEstado, setTiposEstado] = useState([]);

  useEffect(() => {
    if (!id) return;

    const load = async () => {
      try {
        setLoading(true);

        // 1️⃣ Cargar Estado
        const estado = await appFetchJson(apiRoutes.estado.detail(id));
        setNombre(estado.nombre);
        setTipoId(estado.tipoId || "");

        // 2️⃣ Cargar Tipos de Estado (para el combo)
        const tipos = await appFetchJson(
          apiRoutes.estadoTipo.listUrl({ page: 0, size: 100 }),
        );
        setTiposEstado(tipos.items || []);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  const handleSave = async () => {
    try {
      await appFetchJson(apiRoutes.estado.update(id), {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nombre,
          tipoId,
        }),
      });

      onSaved();
      onClose();
    } catch (e) {
      // error ya notificado globalmente
    }
  };

  if (loading) {
    return (
      <ModalBase title="Cargando..." onClose={onClose}>
        <div className="text-center py-6">Cargando…</div>
      </ModalBase>
    );
  }

  return (
    <ModalBase
      title="Editar Estado"
      onClose={onClose}
      footer={
        <div className="btn-row">
          <BtnGuardar
            isValid={nombre.trim() !== "" && tipoId !== ""}
            saving={false}
            onClick={handleSave}
          />
          <BtnCancelar onClick={onClose} />
        </div>
      }
    >
      <div className="form-grid">
        <FilaEdit
          label="Descripción"
          input={
            <input
              type="text"
              className="input"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          }
        />

        <FilaEdit
          label="Estado Tipo"
          input={
            <select
              className="input"
              value={tipoId}
              onChange={(e) => setTipoId(e.target.value)}
            >
              <option value="">--- Seleccione ---</option>
              {tiposEstado.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.nombre}
                </option>
              ))}
            </select>
          }
        />
      </div>
    </ModalBase>
  );
}

/* === COMPONENTES COMPARTIDOS (igual que EditarPermiso.jsx) === */

function Fila({ label, value }) {
  return (
    <div className="form-row gap-2">
      <div className="form-label">{label}:</div>
      <div className="value">{value}</div>
    </div>
  );
}

function FilaEdit({ label, input }) {
  return (
    <div className="form-row gap-2 items-start">
      <div className="form-label">{label}:</div>
      <div className="flex-1">{input}</div>
    </div>
  );
}
